<div [id]="inputId" [hidden]="!showMap" [style.height]="showHeightPercentage ? mapHeight+'%' : mapHeight+'px'"></div>